var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcProcess03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_process_03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.2404 11.3208L6 50.3208L28.2404 89.3208H29.0549H72.7596L95 50.3208L72.7596 11.3208H28.2404ZM31.8893 14.1065H69.1107L50.5 47.4508L31.8893 14.1065ZM29.2709 15.1566L48.8983 50.3208L29.2709 85.485L9.21703 50.3208L29.2709 15.1566ZM71.7291 15.1566L91.783 50.3208L71.7291 85.485L52.1017 50.3208L71.7291 15.1566ZM50.5 53.1908L69.1107 86.5351H31.8893L50.5 53.1908Z",
    fill: "white",
    stroke: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProcess03);
export default __webpack_public_path__ + "static/media/ic_process_03.dd223d7d91bd39ccdd061af350a68b97.svg";
export { ForwardRef as ReactComponent };